import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Module } from 'app/library/module/models/module.model';
import { ModuleFormGuard } from 'app/main/pages/modules/module-form/module-form.guard';
import { ModuleStatuses } from '../../../models/module-statuses';

@Component({
    selector: 'app-content-structure',
    templateUrl: './content-structure.component.html',
    styleUrls: ['./content-structure.component.scss'],
})
export class ContentStructureDialogComponent implements OnInit {
    @Input()
    currentModule: Module;

    isDisablesTrackOptions = false;
    ruleOpts: {
        dontTrackProgress: string;
        trackProgress: string;
        sequential: string;
    };

    constructor(public moduleFormService: ModuleFormGuard, public dialogRef: MatDialogRef<ContentStructureDialogComponent>) {
        this.ruleOpts = ModuleStatuses.ruleOpts;
    }

    ngOnInit(): void {
        if (this.moduleFormService.moduleContentForm.controls.rule.value === this.ruleOpts.dontTrackProgress && this.currentModule.status !== 'unpublished') {
            this.isDisablesTrackOptions = true;
        }
    }

    handleChange($event): void {
        if (!$event.value) {
            this.moduleFormService.moduleContentForm.controls.rule.disable();
        } else {
            this.moduleFormService.moduleContentForm.controls.rule.enable();
        }
    }

    /**
     * Save selected course layout
     */
    saveSelected(): void {
        const formData = this.moduleFormService.moduleContentForm.getRawValue();

        this.dialogRef.close({
            data: {
                hasSections: formData.structure,
                rule: formData.rule,
            },
        });
    }
}
